import { Box, Center, Flex, Image, Text } from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "~/assets/logo.svg";
import { useCurrentAdministratorQuery } from "./index.generated";
import { WhiteOutlineButton } from "~/routes/_shared/Buttons";

export const AdminSidebar = () => {
  const navigate = useNavigate();

  const [currentAdministratorRes] = useCurrentAdministratorQuery();
  const currentAdministrator =
    currentAdministratorRes.data?.currentAdministrator;
  return (
    <Box
      width={"20%"}
      bgColor="#0f2446"
      color="white"
      h="100vh"
      flexGrow={0}
      position="sticky"
      top="0px"
      flexShrink={0}
    >
      <Flex direction="column" justifyContent="space-between" h="full">
        <Box mt="10%" ml="10%" mr="14%">
          <Link to={`/admin`}>
            <Image src={logo} w="full" />
          </Link>
          <Text mt="10%" fontWeight={"bold"} fontSize="xl">
            {currentAdministrator?.name || "未登録"}
          </Text>
        </Box>
        <Center>
          <Flex mb="20%" mx="10%" gap={3} direction="column" w="full">
            <NavigateButton />
            <WhiteOutlineButton
              onClick={() => {
                localStorage.removeItem("jwt_token");
                navigate("/admin/login");
              }}
              label="ログアウト"
            />
          </Flex>
        </Center>
      </Flex>
    </Box>
  );
};

const NavigateButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const button =
    location.pathname === "/admin/users" ? (
      <WhiteOutlineButton
        onClick={() => navigate("/admin")}
        label="特約店を編集"
      />
    ) : (
      <WhiteOutlineButton
        onClick={() => navigate("/admin/users")}
        label="ユーザーを編集"
      />
    );

  return button;
};
